import { ChevronDown, Check } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useLocalizedTranslation } from './Translation';

interface FeatureSegment {
  id: string;
  title: string;
  rows: FeatureRow[];
}

interface FeatureRow {
  name: string;
  availability: string[];
  tooltip?: string;
}

const features: FeatureSegment[] = [
  {
    title: 'Datenschutzmanagement und -prozesse',
    id: 'datenschutzmanagement-und-prozesse',
    rows: [
      { name: 'Allgemeine Hinweise zur DSGVO', availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'] },
      {
        name: 'Nutzung des integrierten Datenschutz-Management-System',
        availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'],
      },
      {
        name: 'DSGVO-konforme Datenschutzerklärung',
        availability: ['(✓)', '', '✓', '✓', '✓', '✓', '✓', '✓'],
      },
      { name: 'DSGVO-Website-Scanner', availability: ['(✓)', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      {
        name: 'Datenschutz-Folgenabschätzungen inkl. Risikoanalyse',
        availability: ['', '', '', '✓', '✓', '', '✓', '✓'],
      },
      { name: 'Unterstützung bei Datenschutz-Folgenabschätzungen', availability: ['', '', '', '✓', '✓', '', '✓', '✓'] },
      { name: 'Erstellung eines Löschkonzeptes', availability: ['(✓)', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Erstellung der gesamten DSGVO-Dokumentation', availability: ['', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Verarbeitungsverzeichnis & Löschkonzept', availability: ['(✓)', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Verwaltung bestehender Dokumente', availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Beantwortung von Betroffenenanfragen', availability: ['', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Anzahl User mit Rechteverwaltung', availability: ['1', '1', '1', '3', '10', '3', '10', '5'] },
      {
        name: 'Anzahl Website-Scans',
        availability: ['2', '0', '2', '5', '10', '2/Mandant', '5/Mandant', '2/Mandant'],
      },
      {
        name: 'Anzahl absicherbarer Webseiten',
        availability: ['1', '', '1', '2', '5', '1/Mandant', '1/Mandant', '1/Mandant'],
      },
      { name: 'Automatische Updates', availability: ['✓', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      {
        name: 'Automatisierte Anpassungen an rechtliche Änderungen',
        availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'],
      },
      { name: 'DSGVO Abmahnschutz', availability: ['✓', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Datenschutzanfragen / Datenpannen', availability: ['', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Beantwortung von Betroffenenanfragen', availability: ['', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      {
        name: 'DSGVO-konformer Umgang mit Datenschutzverletzungen',
        availability: ['', '', '✓', '✓', '✓', '✓', '✓', '✓'],
      },
      { name: 'Rechtssichere Einwilligungen erstellen', availability: ['', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Hosting auf DE-Servern', availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'White-Label-Lösung', availability: ['', '', '', '', '', 'auf Anfrage', 'auf Anfrage', 'auf Anfrage'] },
      {
        name: 'Generator für Technische und organisatorische Maßnahmen (TOMs)',
        availability: ['(✓)', '', '✓', '✓', '✓', '✓', '✓', '✓'],
      },
      {
        name: 'Generator für Auftragsverarbeitung (AV-Vertrag)',
        availability: ['(✓)', '', '✓', '✓', '✓', '✓', '✓', '✓'],
      },
      { name: 'Video-Überwachung', availability: ['', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
    ],
  },
  {
    id: 'website-und-online-datenschutz',
    title: 'Website- und Online-Datenschutz',
    rows: [
      { name: 'Integration per Live-API', availability: ['✓', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      // { name: 'Cookie Consent Tool (20.000 Sessions/Webprojekt)', availability: ['', '', '', '', '', '✓', '✓', ''] },
      { name: 'Datenschutzerklärung-Generator', availability: ['(✓)', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Datenschutzerklärung für Social Media', availability: ['(✓)', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Impressums-Generator', availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'] },
      {
        name: 'Umfassende Cookie-Datenbank, Drittanbietern und externen Diensten',
        availability: ['(✓)', '', '✓', '✓', '✓', '✓', '✓', '✓'],
      },
    ],
  },
  {
    id: 'tools-und-plattformen',
    title: 'Tools und Plattformen',
    rows: [
      { name: 'Datenschutz Score', availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Datenbank zur Speicherung von Dokumenten', availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Datenschutz E-Learning Plattform', availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Rechtstexte Plugin für CMS', availability: ['✓', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Online Zugriff auf Ihre Dokumentationen', availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Praxisorientiertes Taskmanagement', availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Mandantenverwaltung im Dashboard', availability: ['', '', '', '', '', '✓', '✓', '✓'] },
      { name: 'Multi-User-Fähigkeit', availability: ['', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
    ],
  },
  {
    id: 'datenschutz-fuer-mitarbeiter',
    title: 'Datenschutz für Mitarbeiter',
    rows: [
      {
        name: 'Datenschutzrechtliche Grundschulung (Anzahl Nutzer/Mitarbeiter)',
        availability: ['1', '1', '10', '30', '50', '10', '30', '30'],
      },
      { name: 'Rechtssichere Einwilligungen verwalten', availability: ['', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'DSGVO-Verpflichtung', availability: ['', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Homeoffice', availability: ['', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Bewerbung & Anstellung', availability: ['', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
    ],
  },
  {
    id: 'umfassende-beratung',
    title: 'Umfassende Beratung',
    rows: [
      { name: 'Persönliche Beratung durch Datenschutzexperten', availability: ['', '', '', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Praxisorientierte Handlungsempfehlungen', availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Umfassende DSGVO-Analyse des Unternehmens', availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'] },
    ],
  },
  {
    id: 'projekt-und-mandantenmanagement',
    title: 'Projekt- und Mandantenmanagement',
    rows: [
      { name: 'Abkopplung der Mandantenaccounts nach Projektende', availability: ['', '', '', '', '', '✓', '✓', '✓'] },
      { name: 'Projekte/Mandantenverwaltung', availability: ['', '', '', '', '', '✓', '✓', '✓'] },
    ],
  },
  {
    id: 'kundenservice-und-support',
    title: 'Kundenservice und Support',
    rows: [
      { name: 'FAQ-Sammlung', availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Mail Kundensupport (Mo-Fr)', availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Telefonischer Kundensupport (Mo-Fr)', availability: ['', '', '', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Live-Service per Chat', availability: ['✓', '✓', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Notfall-Support', availability: ['', '', '✓', '✓', '✓', '✓', '✓', '✓'] },
      { name: 'Fester interner Kontakt und priorisierte Bearbeitung', availability: ['', '', '', '', '✓', '', '✓'] },
    ],
  },
  {
    id: 'zusammenarbeit-mit-behoerden',
    title: 'Zusammenarbeit mit Behörden',
    rows: [
      {
        name: 'Bestellung eines TÜV-zertifizierten Datenschutzbeauftragten (DSB)',
        availability: ['', '', '', '✓', '✓', '', '✓'],
      },
      { name: 'Zusammenarbeit mit der zuständigen Aufsichtsbehörde', availability: ['', '', '', '✓', '✓', '', '✓'] },
    ],
  },
  {
    id: 'zertifizierungen-und-siegel',
    title: 'Zertifizierungen und Siegel',
    rows: [{ name: 'Siegel für Webseite & Kundenseiten', availability: ['', '', '✓', '✓', '✓', '✓', '✓', '✓'] }],
  },
];

const PLAN_HEADERS = [
  'Leistung',
  'Einzel\u00ADleistung',
  'Freemium',
  'Basic',
  'Premium',
  'Premium +',
  'Agency Basic',
  'Agency Premium',
  'DSB',
];

export function FeatureTable({ locale = 'de' }: { locale?: string }) {
  const { t: tl } = useLocalizedTranslation(locale);
  const [expandedSegments, setExpandedSegments] = useState<Record<string, boolean>>({});
  const hash = window.location.hash.substring(1);

  const toggleSegment = (segmentId: string) => {
    setExpandedSegments((prev) => ({ ...prev, [segmentId]: !prev[segmentId] }));
    if (!expandedSegments[segmentId]) {
      window.history.replaceState(null, '', `#${segmentId}`);
    }
  };

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const segment = features.find((s) => s.id === hash);
        if (segment) {
          setExpandedSegments((prev) => ({ ...prev, [segment.id]: true }));
        }
      }
    }
  }, [hash]);

  return (
    <div id="dieter-feature-table" className="mt-16 space-y-4 scroll-mt-6">
      <h2 className="text-2xl font-bold text-dieter-black mb-6">{tl('common.compare_features')}</h2>
      {features.map((segment) => {
        const isOpen = expandedSegments[segment.id];
        return (
          <div key={segment.id} id={segment.id} className="rounded-2xl border border-gray-200 overflow-hidden bg-white">
            <button
              type="button"
              onClick={() => toggleSegment(segment.id)}
              className="w-full flex items-center justify-between gap-3 px-4 py-4 sm:px-6 sm:py-5 text-left text-dieter-black font-semibold hover:bg-gray-50 transition-colors"
              aria-expanded={isOpen}
            >
              <span>{segment.title}</span>
              <ChevronDown
                className={`w-5 h-5 shrink-0 text-dieter-purple transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                aria-hidden
              />
            </button>
            {isOpen && (
              <div className="border-t border-gray-200 px-4 py-4 sm:px-6 sm:py-5">
                {/* Desktop Table */}
                <div className="hidden md:block overflow-x-auto">
                  <table className="w-full text-sm text-dieter-black border-collapse">
                    <thead>
                      <tr>
                        {PLAN_HEADERS.map((h) => (
                          <th key={h} className="pb-3 pr-4 text-left font-semibold border-b border-gray-300">
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {segment.rows.map((feature, rowIdx) => (
                        <tr key={rowIdx} className="border-b border-gray-200 last:border-b-0">
                          <td className="py-3 pr-4">{feature.name}</td>
                          {feature.availability.map((cell, cellIdx) => (
                            <td key={cellIdx} className="py-3 pr-4">
                              {cell === '✓' ? (
                                <Check className="w-4 h-4 inline-block text-dieter-purple" aria-hidden />
                              ) : cell === '(✓)' ? (
                                <span className="text-gray-400" title="abhängig von gewählter Einzelleistung">
                                  (✓)
                                </span>
                              ) : cell === '' ? (
                                <span className="text-gray-300">—</span>
                              ) : (
                                <span>{cell}</span>
                              )}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Mobile Cards */}
                <div className="block md:hidden space-y-4">
                  {segment.rows.map((feature, i) => (
                    <div key={i} className="border rounded-lg p-4 shadow-sm">
                      <h4 className="font-semibold text-base mb-2">{feature.name}</h4>
                      <div className="space-y-2">
                        {feature.availability.map((cell, j) => (
                          <div
                            key={j}
                            className="flex justify-between items-center border-b border-gray-100 pb-1 last:border-0"
                          >
                            <span className="text-gray-600">{PLAN_HEADERS[j + 1]}</span>
                            <span>
                              {cell === '✓' ? (
                                <Check className="w-4 h-4 inline-block text-dieter-purple" />
                              ) : cell === '' ? (
                                <span className="text-gray-300">—</span>
                              ) : (
                                cell
                              )}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
